@if (showElement) {
    <adapt-dashboard-element name="Peer Catch-ups"
                             [url]="url$ | async">
        @if (teamMembers.length > 1) {
            <adapt-catchup-ratings-graph class="catchup-ratings-graph"
                                         [catchups]="peerCatchUps"
                                         [totalRelationshipCount]="totalRelationshipCount"></adapt-catchup-ratings-graph>
        }
        <ol class="catchup-counts">
            @for (catchupCount of catchupCounts; track catchupCount) {
                <li>
                    <span class="catchup-count">{{ catchupCount.count }}</span>
                    <span>{{ catchupCount.label }}</span>
                </li>
            }
        </ol>
        <button *adaptIfAuthorised="EditMyPeerCatchup; entity: team"
                adaptButtonIcon="add"
                (click)="newCatchup()">Start a new catch-up</button>
    </adapt-dashboard-element>
}
